export default "__VITE_ASSET__DJGM5ARD__"